import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "es-day-model-content w-full" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = {
  key: 1,
  class: "main-m mleft-02"
}

import { ref, watch, onMounted, computed } from 'vue';
import { AppointmentTypeApi, AppointmentTypeResponse, PersonLightResponse } from '@/apiGenerate/medserver';
import { medServerApiConfig } from '@/config/medserver-api.config';
import { ItemSelect, ItemTag } from '@/models/share.model';
import { useI18n } from 'vue-i18n';
import EsDailyCalendar from '@/components/calendar/esDailyCalendar.vue';
import { DurationInput, EventClickArg } from '@fullcalendar/core';
import { DateClickArg } from '@fullcalendar/interaction';
import { useAppUserStore } from '@/stores/appUser';


export default /*@__PURE__*/_defineComponent({
  __name: 'esCalendarDayModelContent',
  props: {
    selectedInstituteId: {},
    refreshData: { type: Boolean },
    selectedHealthPro: {},
    selectedDayModel: {},
    getEventByDay: { type: Function },
    scroll: {}
  },
  emits: ['refreshed', 'openUpdateTimeslotForm', 'openAddTimeslotForm', 'updateEvent'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const { t } = useI18n();
const appUserStore = useAppUserStore();

const appointmentTypeApi = new AppointmentTypeApi(medServerApiConfig);

const currentDayModel = ref<ItemSelect>(props.selectedDayModel);
const itemTags = ref<ItemTag[]>([]);
const refreshDayModel = ref<boolean>(false);

const today = new Date();
const minTime = new Date(today);
minTime.setHours(0, 0, 0, 0);
const maxTime = new Date(today);
maxTime.setHours(24, 0, 0, 0);
const calendarApi = ref(null);

const emits = __emit;

const currentPersonId = computed(() => {
  if (!appUserStore.currentAppUserData || !appUserStore.currentAppUserData.healthGroupMemberships) {return null}
  return appUserStore.currentAppUserData.healthGroupMemberships[0].pwr.personWithRoleId
});

const transformToItemTags = (appointmentType: AppointmentTypeResponse):ItemTag => {
  return {
    id: appointmentType.appointmentTypeId,
    label: appointmentType.name,
    selected: true,
    opened: true
  }
}


const findAppointmentType = async () => {
  if (props.selectedInstituteId && (currentPersonId.value || props.selectedHealthPro?.id)) {
    appointmentTypeApi.listAppointmentTypes({instituteId: props.selectedInstituteId, isSetting: false, doctorId: props.selectedHealthPro?.id ? props.selectedHealthPro.id : currentPersonId.value}).then((response: AppointmentTypeResponse[]) => {
      itemTags.value = response.map((appointmentType: AppointmentTypeResponse) => transformToItemTags(appointmentType));
    });
  }
}

const openUpdateTimeslotForm = async (data : {info: EventClickArg, item: ItemTag}) => {
    emits('openUpdateTimeslotForm', data);
}

const openAddTimeslotForm = async (data : {info: DateClickArg, item: ItemTag}) => {
    emits('openAddTimeslotForm', data);
}

const refreshData = async() => {
  await findAppointmentType();

  emits('refreshed');
}

watch(
    () => props.selectedInstituteId,
  () => {
    refreshData();
  }
);

watch(
  () => props.selectedHealthPro,
  () => {
    refreshData();
  }
)

watch(
  () => props.selectedDayModel,
  () => {
    currentDayModel.value = props.selectedDayModel;
  }
)

watch(
  () => props.refreshData,
  async (newVal) => {
    if (newVal === true) {
      await findAppointmentType();
      emits('refreshed');
    }
  }
);

onMounted(() => {
  refreshData();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (currentDayModel.value)
        ? (_openBlock(), _createBlock(EsDailyCalendar, {
            key: 0,
            customRef: "dayModelDailyCalendar",
            itemTags: itemTags.value,
            getEventByDay: _ctx.getEventByDay,
            refresh: refreshDayModel.value,
            calcHeight: 550,
            smallDisplay: true,
            cssEventClass: 'pleft-04 txt-white',
            displayNowIndicator: false,
            getBusinessHours: false,
            getAppointmentmentTypes: false,
            "nb-calendar": 6,
            scroll: _ctx.scroll,
            isSetting: true,
            eventDurationEditable: true,
            droppable: true,
            onNavigationChanged: _cache[0] || (_cache[0] = ($event: any) => (refreshDayModel.value = true)),
            onRefreshed: _cache[1] || (_cache[1] = ($event: any) => (refreshDayModel.value = $event)),
            onOpenAddForm: _cache[2] || (_cache[2] = ($event: any) => (openAddTimeslotForm($event))),
            onEventClick: _cache[3] || (_cache[3] = ($event: any) => (openUpdateTimeslotForm($event))),
            onExposeApi: _cache[4] || (_cache[4] = ($event: any) => (calendarApi.value = $event)),
            onUpdateEvent: _cache[5] || (_cache[5] = ($event: any) => (emits('updateEvent', $event)))
          }, null, 8, ["itemTags", "getEventByDay", "refresh", "scroll"]))
        : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(t)('settings.label.dayModel.selectOrCreate')), 1))
    ])
  ]))
}
}

})